import { render } from "./NotFound.vue?vue&type=template&id=3799c56a&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=3799c56a&scoped=true&lang=css"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3799c56a"]])

export default __exports__